import React, { useState, FC } from 'react'
import { Button } from 'antd'
import { BaseButtonProps } from 'antd/lib/button/button'

interface IPops extends BaseButtonProps {
    onClick: () => Promise<any>
    text?: string
    style?: React.CSSProperties,
    svg?: React.ReactNode
}

const LoadingBtn: FC<IPops> = (props) => {
    const [loading, setLoading] = useState<boolean>(false)

    const handleClick = async () => {
        setLoading(true)
        
        await props.onClick().finally(() => {
            setLoading(false)
        })
    }

    return (
        <Button
            {...props}
            loading={loading}
            style={props.style}
            type={props.type}
            icon={props.icon}
            onClick={handleClick}
        >
            {props.children || props.text}
        </Button>
    )
}
LoadingBtn.defaultProps = {
    text: "导出EXCEL"
}

export default LoadingBtn
